import React from 'react';
import { FieldGroup, Select } from 'library/ui';
import { useHistory } from 'react-router';

import type { PagingResult, IBusinessLocation } from 'models';

export function LocationsDropDown({ data, location }: { data?: PagingResult<IBusinessLocation>; location?: string }) {
    const history = useHistory();
    const paramLocation = new URLSearchParams(window.location.search).get('location');
    function handleLocationChange(value: string) {
        const params = new URLSearchParams(window.location.search);
        params.set('location', value);
        const url = `timesheets?${params.toString()}`;
        history.push(url);
    }

    return (
        <FieldGroup label="Location">
            <Select
                value={paramLocation || location || ''}
                options={
                    data?.results
                        .slice()
                        .sort((a, b) => Number(!!a.deleted_at) - Number(!!b.deleted_at))
                        .map((b) => ({ key: b.id.toString(), value: b.deleted_at ? `${b.name} (deleted)` : b.name })) ||
                    []
                }
                onChange={handleLocationChange}
                fullWidth
                tone="primary"
            />
        </FieldGroup>
    );
}
